<div class="main-tab-title-box">
    <mat-card-title class="main-title">Metadiscourse</mat-card-title>
    <div>
        <analysis-options></analysis-options>
    </div>
</div>
<mat-card-content>
    <div class="box-login">
        <span class="main-box-title-14">As this is a subscriber’s feature, you are seeing sample results. In order to  <br>see the real results of your text, <u class="main-box-value-14-bold"><a href="https://textinspector.com/subscription-details/" style="color: #2A3654;" target="_blank" rel="noopener noreferrer">SUBSCRIBE NOW.</a></u></span>
    </div>


    <div id="button-switch-box">
        <div class="button-container left" [ngClass]="{'selected': isSelected('summary')}"
            (click)="selectMenuItem('summary')">
            <div style="margin-top: 9px;">
                <span class="main-box-title-14">Summary</span>
            </div>
        </div>
        <div class="separator"></div>
        <div class="button-container right" [ngClass]="{'selected': isSelected('charts')}"
            (click)="selectMenuItem('charts')">
            <div style="margin-top: 8px;">
                <img style="margin-right: 8px; padding-bottom: 2px; vertical-align: middle;"
                    src="./assets/images/extra_tab_icons/charts-icon.svg">
                <span class="main-box-title-14" style="padding-top: 2px;">Charts</span>
            </div>
        </div>
    </div>

    <ng-container *ngIf="selectedMenuItem === 'summary'">

        <span class="main-box-title-14">This tool analyses your text according to the Academic Word List or AWL (Coxhead,
            2000).
            Click here for an explanation. It also analyses your text in terms of key Phrases identified by Martinez and
            Schmitt (Martinez and Schmitt, 2012), identified as K1, K2 and so on, as discussed here.
            If you want to correct any analysis, go to Input below, change the tag, then click Update.</span>
            
        <div id="buttons-box">
            <div style="width: 70px;">

            </div>
            <span style="padding-left: 15px;">
                <button class="icon-button">
                    <span class="button-block"><div><img src="../assets/images/yellow_icons/blocked-icon.svg" class="export-con"></div><span>Metadiscourse
                        Export</span></span>
                </button>
            </span>

        </div>
        <div id="div_scroll">
            <div id="metadiscourse-box">
                <div style="width: 70px;">
                    <button mat-button style="visibility: hidden; display: inline-block;">
                        <img class="eye-icon" style="padding-left: 10px;" src="./assets/images/eye-icon.svg">
                        <span>See All</span>
                    </button>
                </div>
                <div class="main-box-title-14"
                    style="align-items: flex-end; display: flex; height: 30px; width: 80px; ">
                    Word</div>
                <div style="width: 130px; height: 20px; "></div>
                <div class="main-box-title-14"
                    style="align-items: flex-end; display: flex; height: 30px; width: 80px; ">
                    Types</div>
                <div style="width: 80px; height: 20px; "></div>
                <div class="main-box-title-14"
                    style="align-items: flex-end; display: flex; height: 30px; width: 80px; ">
                    Tokens</div>
                <div style="width: 70px; height: 20px; "></div>
            </div>

            <div class="vertical-box">
                <div class="horizontal-box" style="border: none; margin-bottom: 0px;"
                    [ngClass]="{'expanded': isExpanded['TOTAL']}" (click)="toggleExpand('TOTAL')">
                    <div style="display: flex;">
                        <img class="eye_icon" src="../../assets/images/eye-icon.svg">
                        
                    </div>
                    <span id="box-score" style="color: #2A3654;">Total</span>
                    <div style="width: 180px; height: 30px; "></div>
                    <div class="main-box-title-14" id="div_size">{{types_total ? types_total : "--"}} (6.81%)</div>
                    <div style="width: 60px; height: 30px; "></div>
                    <div class="main-box-title-14" id="div_size">{{tokens_total ? tokens_total : "--"}} (6.81%)</div>
                    <mat-icon class="expand-icon" >expand_more</mat-icon>
                </div>
                <div class="horizontal-box"
                    style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;"
                    *ngIf="isExpanded['TOTAL']">
                    <div class="vertical-box" *ngFor="let chunk of dividedData['TOTAL']"
                        style="border: none; margin-bottom: 0px; padding: 0px;">
                        <div *ngFor="let item of chunk">
                            <p class="text-item">{{item.word}} / {{item.count}}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="vertical-box">
                <div class="horizontal-box" style="border: none; margin-bottom: 0px;"
                    [ngClass]="{'expanded': isExpanded['ATTITUDE']}" (click)="toggleExpand('ATTITUDE')">
                    
                        <div style="display: flex;">
                            <img class="eye_icon" src="../../assets/images/eye-icon.svg">
                        </div>
                        <span id="box-score" style="background-color: #6C2D8E;">Attitude Marker</span>
                        <div class="tooltip-container">
                            <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                            <span class="tooltip-text">A word or phrase used to convey the writer's attitude or opinion about the information presented, allowing the writer to express evaluation or stance (e.g., "unfortunately," "interestingly," "surprisingly").</span>
                        </div>
                    
                    <div style="width: 80px; height: 30px; "></div>
                    <div class="main-box-title-14" id="div_size">{{types_attitude ? types_attitude : "--"}} (0.43%)
                    </div>
                    <div style="width: 60px; height: 30px; "></div>
                    <div class="main-box-title-14" id="div_size">{{tokens_attitude ? tokens_attitude : "--"}} (0.29%)
                    </div>
                    <mat-icon class="expand-icon" >expand_more</mat-icon>
                </div>
                <div class="horizontal-box"
                    style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;"
                    *ngIf="isExpanded['ATTITUDE']">
                    <div class="vertical-box" *ngFor="let chunk of dividedData['ATTITUDE']"
                        style="border: none; margin-bottom: 0px; padding: 0px;">
                        <div *ngFor="let item of chunk">
                            <p class="text-item">{{item.word}} / {{item.count}}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="vertical-box">
                <div class="horizontal-box" style="border: none; margin-bottom: 0px;"
                    [ngClass]="{'expanded': isExpanded['EMPHATIC']}" (click)="toggleExpand('EMPHATIC')">
                    
                        <img class="eye_icon" src="../../assets/images/eye-icon.svg">
                        <span id="box-score" style="background-color: #0075FF;">Emphatic</span>
                        <div class="tooltip-container">
                            <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                            <span class="tooltip-text">Serve to strengthen or emphasize a particular point or statement. They make the writer's claim more forceful or certain (e.g., "definitely," "absolutely," "clearly," "undoubtedly").</span>
                        </div>
                    
                    <div style="width: 125px; height: 30px; "></div>
                    <div class="main-box-title-14" id="div_size">{{types_emphatic ? types_emphatic : "--"}} (0.85%)
                    </div>
                    <div style="width: 60px; height: 30px; "></div>
                    <div class="main-box-title-14" id="div_size">{{tokens_emphatic ? tokens_emphatic : "--"}} (0.87%)
                    </div>
                    <mat-icon class="expand-icon" >expand_more</mat-icon>
                </div>
                <div class="horizontal-box"
                    style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;"
                    *ngIf="isExpanded['EMPHATIC']">
                    <div class="vertical-box" *ngFor="let chunk of dividedData['EMPHATIC']"
                        style="border: none; margin-bottom: 0px; padding: 0px;">
                        <div *ngFor="let item of chunk">
                            <p class="text-item">{{item.word}} / {{item.count}}</p>
                        </div>
                    </div>
                </div>
            </div>


            <div class="vertical-box">
                <div class="horizontal-box" style="border: none; margin-bottom: 0px;"
                    [ngClass]="{'expanded': isExpanded['EVIDENTIAL']}" (click)="toggleExpand('EVIDENTIAL')">
                 
                        <img class="eye_icon" src="../../assets/images/eye-icon.svg">
                        <span id="box-score" style="background-color: #1A8583;">Evidential</span>
                        <div class="tooltip-container">
                            <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                            <span class="tooltip-text">An indication of the source of the information, showing where the writer's knowledge or evidence comes from. They help establish the reliability of the claims (e.g., "according to," "as reported by," "based on studies").</span>
                        </div>
                    
                    <div style="width: 120px; height: 30px; "></div>
                    <div class="main-box-title-14" id="div_size">{{types_evidential ? types_evidential : "--"}} (0.85%)
                    </div>
                    <div style="width: 60px; height: 30px; "></div>
                    <div class="main-box-title-14" id="div_size">{{tokens_evidential ? tokens_evidential : "--"}}
                        (0.58%)
                    </div>
                    <mat-icon class="expand-icon" >expand_more</mat-icon>
                </div>
                <div class="horizontal-box"
                    style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;"
                    *ngIf="isExpanded['EVIDENTIAL']">
                    <div class="vertical-box" *ngFor="let chunk of dividedData['EVIDENTIAL']"
                        style="border: none; margin-bottom: 0px; padding: 0px;">
                        <div *ngFor="let item of chunk">
                            <p class="text-item">{{item.word}} / {{item.count}}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="vertical-box">
                <div class="horizontal-box" style="border: none; margin-bottom: 0px;"
                    [ngClass]="{'expanded': isExpanded['HEDGE']}" (click)="toggleExpand('HEDGE')">
                    
                        <img class="eye_icon" src="../../assets/images/eye-icon.svg">
                        <span id="box-score" style="background-color: #F60D16;">Hedge</span>
                        <div class="tooltip-container">
                            <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                            <span class="tooltip-text">A word or phrase used to soften the impact of a statement, making it less direct or less assertive. They are used to express uncertainty, possibility, or politeness (e.g., "might," "seem," "possibly," "perhaps").</span>
                        </div>
                    
                    <div style="width: 145px; height: 30px; "></div>
                    <div class="main-box-title-14" id="div_size">{{types_hedge ? types_hedge : "--"}} (0.85%)</div>
                    <div style="width: 60px; height: 30px; "></div>
                    <div class="main-box-title-14" id="div_size">{{tokens_hedge ? tokens_hedge : "--"}} (0.58%)</div>
                    <mat-icon class="expand-icon" >expand_more</mat-icon>
                </div>
                <div class="horizontal-box"
                    style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;"
                    *ngIf="isExpanded['HEDGE']">
                    <div class="vertical-box" *ngFor="let chunk of dividedData['HEDGE']"
                        style="border: none; margin-bottom: 0px; padding: 0px;">
                        <div *ngFor="let item of chunk">
                            <p class="text-item">{{item.word}} / {{item.count}}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="vertical-box">
                <div class="horizontal-box" style="border: none; margin-bottom: 0px;"
                    [ngClass]="{'expanded': isExpanded['LOGICAL']}" (click)="toggleExpand('LOGICAL')">
                    
                        <img class="eye_icon" src="../../assets/images/eye-icon.svg">
                        <span id="box-score" style="background-color: #15622B;">Logical Connective</span>
                        <div class="tooltip-container">
                            <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                            <span class="tooltip-text">A word or phrase used to link ideas, sentences, or clauses together logically, helping to structure the argument or discussion. They show relationships like cause-effect, contrast, addition, etc. (e.g., "therefore," "however," "in addition," "because").</span>
                        </div>
                    
                    <div style="width: 50px; height: 30px; "></div>
                    <div class="main-box-title-14" id="div_size">{{types_logical ? types_logical : "--"}} (2.55%)</div>
                    <div style="width: 60px; height: 30px; "></div>
                    <div class="main-box-title-14" id="div_size">{{tokens_logical ? tokens_logical : "--"}} (3.79%)
                    </div>
                    <mat-icon class="expand-icon" >expand_more</mat-icon>
                </div>
                <div class="horizontal-box"
                    style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;"
                    *ngIf="isExpanded['LOGICAL']">
                    <div class="vertical-box" *ngFor="let chunk of dividedData['LOGICAL']"
                        style="border: none; margin-bottom: 0px; padding: 0px;">
                        <div *ngFor="let item of chunk">
                            <p class="text-item">{{item.word}} / {{item.count}}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="vertical-box">
                <div class="horizontal-box" style="border: none; margin-bottom: 0px;"
                    [ngClass]="{'expanded': isExpanded['PERSON']}" (click)="toggleExpand('PERSON')">
                    
                        <img class="eye_icon" src="../../assets/images/eye-icon.svg">
                        <span id="box-score" style="background-color: #FF8EC5;">Person Marker</span>
                        <div class="tooltip-container">
                            <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                            <span class="tooltip-text">Indicating the involvement or perspective of the writer or others in the discourse. They specify who is taking the action or being referred to (e.g., "I," "we," "you," "they").</span>
                        </div>
                    
                    <div style="width: 85px; height: 30px; "></div>
                    <div class="main-box-title-14" id="div_size">{{types_person ? types_person : "--"}} (0.43%)</div>
                    <div style="width: 60px; height: 30px; "></div>
                    <div class="main-box-title-14" id="div_size">{{tokens_person ? tokens_person : "--"}} (0.29%)</div>
                    <mat-icon class="expand-icon" >expand_more</mat-icon>
                </div>
                <div class="horizontal-box"
                    style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;"
                    *ngIf="isExpanded['PERSON']">
                    <div class="vertical-box" *ngFor="let chunk of dividedData['PERSON']"
                        style="border: none; margin-bottom: 0px; padding: 0px;">
                        <div *ngFor="let item of chunk">
                            <p class="text-item">{{item.word}} / {{item.count}}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="vertical-box">
                <div class="horizontal-box" style="border: none; margin-bottom: 0px;"
                    [ngClass]="{'expanded': isExpanded['RELATIONAL']}" (click)="toggleExpand('RELATIONAL')">
                    
                        <img class="eye_icon" src="../../assets/images/eye-icon.svg">
                        <span id="box-score" style="background-color: #8E8E5B;">Relational Marker</span>
                        <div class="tooltip-container">
                            <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                            <span class="tooltip-text">A word or phrase showing the relationship between the writer and the audience. They guide interaction, expressing the writer's stance toward the audience or information (e.g., "as you can see," "let me clarify," "I believe").</span>
                        </div>
                    
                    <div style="width: 65px; height: 30px; "></div>
                    <div class="main-box-title-14" id="div_size">{{types_relational ? types_relational : "--"}} (0.43%)
                    </div>
                    <div style="width: 60px; height: 30px; "></div>
                    <div class="main-box-title-14" id="div_size">{{tokens_relational ? tokens_relational : "--"}}
                        (0.29%)
                    </div>
                    <mat-icon class="expand-icon" >expand_more</mat-icon>
                </div>
                <div class="horizontal-box"
                    style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;"
                    *ngIf="isExpanded['RELATIONAL']">
                    <div class="vertical-box" *ngFor="let chunk of dividedData['RELATIONAL']"
                        style="border: none; margin-bottom: 0px; padding: 0px;">
                        <div *ngFor="let item of chunk">
                            <p class="text-item">{{item.word}} / {{item.count}}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="vertical-box">
                <div class="horizontal-box" style="border: none; margin-bottom: 0px;"
                    [ngClass]="{'expanded': isExpanded['SEQUENCING']}" (click)="toggleExpand('SEQUENCING')">
                    
                        <img class="eye_icon" src="../../assets/images/eye-icon.svg">
                        <span id="box-score" style="background-color: #C5C500;">Sequencing</span>
                        <div class="tooltip-container">
                            <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                            <span class="tooltip-text">Used to organize content in a sequential order, guiding the audience through the structure of an argument or narrative. They help clarify the flow of ideas (e.g., "Firstly," "Then," "Finally").</span>
                        </div>
                    
                    <div style="width: 105px; height: 30px; "></div>
                    <div class="main-box-title-14" id="div_size">{{types_sequencing ? types_sequencing : "--"}} (0.43%)
                    </div>
                    <div style="width: 60px; height: 30px; "></div>
                    <div class="main-box-title-14" id="div_size">{{tokens_sequencing ? tokens_sequencing : "--"}}
                        (0.29%)
                    </div>
                    <mat-icon class="expand-icon" >expand_more</mat-icon>
                </div>
                <div class="horizontal-box"
                    style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;"
                    *ngIf="isExpanded['SEQUENCING']">
                    <div class="vertical-box" *ngFor="let chunk of dividedData['SEQUENCING']"
                        style="border: none; margin-bottom: 0px; padding: 0px;">
                        <div *ngFor="let item of chunk">
                            <p class="text-item">{{item.word}} / {{item.count}}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="vertical-box">
                <div class="horizontal-box" style="border: none; margin-bottom: 0px;"
                    [ngClass]="{'expanded': isExpanded['UNLISTED']}" (click)="toggleExpand('UNLISTED')">
                    
                        <img class="eye_icon" src="../../assets/images/eye-icon.svg">
                        <span id="box-score" style="color: #2A3654;">Unlisted</span>
                        <!-- <div class="tooltip-container">
                            <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
                            <span class="tooltip-text">Lorem ipsum dolor sit amet consetetur sad ipscing elitr sed diam
                                nonumy eirmod temi por invidunt ut labore et dolore magna.</span>
                        </div> -->
                    
                    <div style="width: 130px; height: 30px; "></div>
                    <div class="main-box-title-14" id="div_size">{{types_unlisted ? types_unlisted : "--"}} (93.19%)
                    </div>
                    <div style="width: 60px; height: 30px; "></div>
                    <div class="main-box-title-14" id="div_size">{{tokens_unlisted ? tokens_unlisted : "--"}} (93.00%)
                    </div>
                    <mat-icon class="expand-icon" >expand_more</mat-icon>
                </div>
                <div class="horizontal-box"
                    style="border: none; margin-bottom: 0px; justify-content: space-evenly; width: auto; height: auto; padding: 0;"
                    *ngIf="isExpanded['UNLISTED']">
                    <div class="vertical-box" *ngFor="let chunk of dividedData['UNLISTED']"
                        style="border: none; margin-bottom: 0px; padding: 0px;">
                        <div *ngFor="let item of chunk">
                            <p class="text-item">{{item.word}} / {{item.count}}</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
<!-- 
        <div class="content-show-all">
            <button mat-button style="color:#EEA21A;font-size: 14px;" (click)="toggleExpandAll()">
                Expand all
            </button>
        </div> -->

    </ng-container>


    <ng-container *ngIf="selectedMenuItem === 'charts'">
        <div class="chart-container">
            <div
                style="width: auto;align-items: center; text-align: center; font-size: 14px; font-weight: bold; font-family: 'Inter';color: #2A3654; margin-bottom: 20px;">
                Types %</div>
            <canvas style="width: 70%; height: 200px; margin-left: 1%;margin-right: 1%; padding-bottom: 10px;" baseChart
                [data]="barChartData" [options]="barChartOptions" [type]="barChartType ">
            </canvas>
        </div>
    </ng-container>

</mat-card-content>
